export default __webpack_public_path__ + "images/f2c0cd6b0ea06903da0df53481957119-robotics.jpg";